import React from "react";
import PropTypes from "prop-types";
import { TriyoForm } from "../../../../../../components/TriyoForm";
import "./WorkflowHeader.scss";

const WorkflowHeader = ({ editMode, name, useLegacyMode, onToggleChange, showLegacyToggle }) => {
  const hasToggle = showLegacyToggle && typeof onToggleChange === 'function';

  return (
    <div className="admin-workflow-page-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <h4 className="panel-title">
        {editMode ? "Edit Workflow" : "Create Workflow"}
      </h4>
      {hasToggle && (
        <div className="legacy-toggle-container">
          <span className="legacy-toggle-label">Legacy</span>
          <TriyoForm.Toggle
            id="workflow-mode-toggle"
            label=""
            checked={useLegacyMode}
            onChange={onToggleChange}
            disabled={editMode}
          />
        </div>
      )}
    </div>
  );
};

WorkflowHeader.propTypes = {
  editMode: PropTypes.bool.isRequired,
  name: PropTypes.string,
  useLegacyMode: PropTypes.bool,
  onToggleChange: PropTypes.func,
  showLegacyToggle: PropTypes.bool,
};

export default WorkflowHeader;
